'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

"use strict";
const ENGLISH_US = "en-US";
const FRENCH_FRANCE = "fr-FR";
const SPANISH_SPAIN = "es-ES";
const GERMAN_GERMANY = "de-DE";
const BRAZILIAN_PORTUGUESE = "pt-BR";
const CHINESE_SIMPLIFIED = "zh-Hans";
const ITALIAN_ITALY = "it-IT";
const JAPANESE_JAPAN = "ja-JP";
const INDONESIAN_INDONESIA = "id-ID";
const KOREAN_KOREA = "ko-KR";
const RUSSIAN_RUSSIA = "ru-RU";
const CZECH_CZECHIA = "cs-CZ";
const DUTCH_NETHERLANDS = "nl-NL";
const HUNGARIAN_HUNGARY = "hu-HU";
const PORTUGUESE_PORTUGAL = "pt-PT";
const POLISH_POLAND = "pl-PL";
const SWEDISH_SWEDEN = "sv-SE";
const TURKISH_TURKEY = "tr-TR";
const CHINESE_TRADITIONAL = "zh-Hant";
const DEFAULT_LANGUAGE = ENGLISH_US;
const PSEUDO_LOCALE = "pseudo";

exports.BRAZILIAN_PORTUGUESE = BRAZILIAN_PORTUGUESE;
exports.CHINESE_SIMPLIFIED = CHINESE_SIMPLIFIED;
exports.CHINESE_TRADITIONAL = CHINESE_TRADITIONAL;
exports.CZECH_CZECHIA = CZECH_CZECHIA;
exports.DEFAULT_LANGUAGE = DEFAULT_LANGUAGE;
exports.DUTCH_NETHERLANDS = DUTCH_NETHERLANDS;
exports.ENGLISH_US = ENGLISH_US;
exports.FRENCH_FRANCE = FRENCH_FRANCE;
exports.GERMAN_GERMANY = GERMAN_GERMANY;
exports.HUNGARIAN_HUNGARY = HUNGARIAN_HUNGARY;
exports.INDONESIAN_INDONESIA = INDONESIAN_INDONESIA;
exports.ITALIAN_ITALY = ITALIAN_ITALY;
exports.JAPANESE_JAPAN = JAPANESE_JAPAN;
exports.KOREAN_KOREA = KOREAN_KOREA;
exports.POLISH_POLAND = POLISH_POLAND;
exports.PORTUGUESE_PORTUGAL = PORTUGUESE_PORTUGAL;
exports.PSEUDO_LOCALE = PSEUDO_LOCALE;
exports.RUSSIAN_RUSSIA = RUSSIAN_RUSSIA;
exports.SPANISH_SPAIN = SPANISH_SPAIN;
exports.SWEDISH_SWEDEN = SWEDISH_SWEDEN;
exports.TURKISH_TURKEY = TURKISH_TURKEY;
//# sourceMappingURL=constants.cjs.map
